import React from "react";
import "./DeviceManagementHeader.scss";

function DeviceManagementHeader({
  count,
  handleOpen,
  user,
  handleOpenBroadcast,
}) {
  return (
    <div className="table-info-header d-flex justify-content-between">
      <p>
        Total: {count ? count : <>0</>} {user}
      </p>
      <div className="table-options">
        <button onClick={handleOpenBroadcast}>
          <div>Broadcast</div>
        </button>
        <button onClick={handleOpen}>
          <div>Zones</div>
        </button>
      </div>
    </div>
  );
}

export default DeviceManagementHeader;
